<div class="int-dropdown"
   (click)="noop($event)"
>
  <ng-content select="header"></ng-content>
  <div class="int-dropdown__scroll-container" intScrollContainer #drop>
    <ng-content></ng-content>
  </div>
</div>
